var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.661 3.803a.5.5 0 1 1-.707-.707L9.268.78c1.188-1.187 3.242-1 4.596.354s1.541 3.409.354 4.596l-3.536 3.536c-1.187 1.187-3.242 1-4.596-.354a.5.5 0 0 1 .707-.707c.99.99 2.417 1.119 3.182.354l3.536-3.536c.765-.765.636-2.193-.354-3.182-.989-.99-2.416-1.119-3.182-.354zm-.321 7.392a.5.5 0 0 1 .707.707l-2.314 2.314c-1.187 1.188-3.242 1-4.596-.353-1.354-1.354-1.541-3.41-.354-4.596L4.319 5.73c1.187-1.187 3.242-1 4.596.354a.5.5 0 1 1-.707.707c-.99-.99-2.417-1.12-3.182-.354L1.49 9.974c-.765.765-.635 2.193.354 3.182s2.416 1.119 3.182.353z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgLink;